import React, { useEffect, useState } from "react";
import styles from "./form.module.css";
import { withDecorators } from "@/utils/StylesUtils";
import {
  Input,
  InputType,
  InputValidation,
  InputValidationType,
} from "@/components/input";
import { Button, ButtonType } from "@/components/button";

export enum FormActionType {
  SUBMIT = "SUBMIT"
}

export interface FormAction {
  title: string;
  type?: FormActionType;
  action?: any;
}

export interface FormColumn {
  title?: string;
  name: string;
  type: InputType;
  required?: boolean;
  value?: any;
  className?: string;
  label?: any;
  validations?: InputValidation[];
}

export interface FormRow {
  className?: string;
  columns: FormColumn[];
}

export interface FormProps {
  className?: string;
  rows: FormRow[];
  action?: FormAction;
  initialData?: object;
  onChange?: (value: any) => void;
}

const validateValue = (validation: InputValidation, value: any) => {
  switch (validation.type) {
    case InputValidationType.TRUE:
      return value ? null : validation;
    case InputValidationType.NOT_EMPTY:
      return (typeof value.length == 'undefined' || (value && value.length > 0)) ? null : validation;
  }
};

const validateItem = (validations: InputValidation[], value: any) => {
  if (!validations) {
    return null;
  }

  const validationsResult = validations
    .map((validation: InputValidation) => {
      return validateValue(validation, value);
    })
    .filter((item: any) => item != null);

  return validationsResult.length == 0 ? null : validationsResult;
};

const validateForm = (validations: any, formData: any) => {
  const validationsResult = Object.keys(validations).map((item) => {
    const itemValidations = validateItem(validations[item], formData[item]);

    return {
      [item]:
        itemValidations,
    };
  });

  return {
    validations: validationsResult,
    valid:
      Object.values(validationsResult)
        .map((item) => Object.values(item)[0])
        .filter((item) => item != null).length == 0,
  };
};

export const Form = (props: FormProps) => {
  const { rows, className, action, initialData = {}, onChange } = props;

  const [formData, setFormData] = useState<any>(initialData);

  const inputsValidations : any = rows.reduce((acc, rowItem) => {
    return {
      ...acc,
      ...rowItem.columns.reduce((accRow, colItem) => {
        return {
          ...accRow,
          [colItem.name]: colItem.validations,
        };
      }, {}),
    };
  }, {});

  const [formErrors, setFormErrors] = useState<any>(
    Object.keys(inputsValidations)
      .map((item) => ({ [item]: null }))
      .reduce((acc, item) => {
        return {
          ...acc,
          [Object.keys(item)[0]]: Object.values(item)[0],
        };
      }, {})
  );

  useEffect(() => {
    //setFormData(initialData);
  }, [rows, initialData]);

  return (
    <form
      className={styles.form + (className ? ` ${className}` : "")}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();

        console.log("A validar el form", formData, inputsValidations);
        const validatedForm = validateForm(inputsValidations, formData);
        console.log("Validated form", validatedForm);

        if (validatedForm.valid && action?.type == FormActionType.SUBMIT) {
          action.action(formData);
          return false;
        }

        setFormErrors(
          validatedForm.validations.reduce((acc, item) => {
            return {
              ...acc,
              [Object.keys(item)[0]]: Object.values(item)[0],
            };
          }, {})
        );
      }}
    >
      {rows.map((row, i) => (
        <div
          className={
            styles.form_row + (row.className ? ` ${row.className}` : "")
          }
          key={i}
        >
          {row.columns.map(((column : any, j) => (
            <Input
              {...column}
              onChange={(value: any) => {
                setFormData({ ...formData, [column.name]: value })

                if (column.onChange) {
                  column.onChange(value);
                }
              }}
              key={j}
              errors={
                formErrors[column.name]
              }
              onBlur={() => {
                const itemValidation = validateItem(inputsValidations[column.name], formData[column.name]);

                setFormErrors({
                  ...formErrors,
                  [column.name]: itemValidation
                });

                if(itemValidation == null){
                  onChange && onChange(formData);
                }
              }}
            />
          )))}
        </div>
      ))}
      {action && <Button fullWidth={true} label={action.title} type={ButtonType.SECONDARY} onClick={() => {
        if(action.type == FormActionType.SUBMIT){
          // Se delega en el submit
          return false;
        }else if(action.action){
          action.action();
        }
      }}/>}
    </form>
  );
};
